module.exports = __webpack_public_path__ + "img/jindocoin_wow_cover.2ffc5eb3.jpg";